import classNames from 'classnames'
import React, { FC } from 'react'

type Props = {
    className?: string;
    badge: string | number;
}

const OnahBadge: FC<Props> = ({badge, className}) => {
  return (
    <div className={classNames(
        "bg-error w-[20px] h-[20px] 2xl:w-[22px] 2xl:h-[22px] text-white", 
        "flex justify-center items-center rounded-full font-extrabold 2xl:text-[14px] text-[12px]",
        className
      )}>
      {badge}
    </div>
  )
};

export default OnahBadge;